import { Spin, Table, TableColumnsType } from "antd";
import { useMemo, useState } from "react";
import { NFTAirdropType } from "../../type";
import { IoCopy } from "react-icons/io5";
import { copyToClipboard, shortenAddress } from "../../helpers";

const AirdropNFT = ({
  airdropNFTs,
  loading,
  handleClaimAirdropNFT,
}: {
  airdropNFTs: NFTAirdropType[];
  loading: boolean;
  handleClaimAirdropNFT: (nft: NFTAirdropType) => Promise<void>;
}) => {
  const [loadingId, setLoadingId] = useState<number | undefined>();

  const handleClaimClick = async (nft: NFTAirdropType) => {
    setLoadingId(nft.id);
    await handleClaimAirdropNFT(nft);
    setTimeout(() => {
      //mock up async response, delete if integrate sc
      setLoadingId(undefined);
    }, 2000);
  };

  const columns: TableColumnsType<NFTAirdropType> = useMemo(
    () => [
      {
        title: () => (
          <div className="font-Montserrat text-sm sm:text-base font-semibold whitespace-nowrap">
            Project
          </div>
        ),
        dataIndex: "project",
        render: (_text, record, _index) => (
          <div className="flex items-center gap-4 lg:min-w-40">
            <img src={record?.logo} alt="" className="w-8 h-8 object-contain" />
            <span className="font-Montserrat text-sm sm:text-base font-medium">
              {record?.project}
            </span>
          </div>
        ),
      },
      {
        title: () => (
          <div className="font-Montserrat text-sm sm:text-base font-semibold whitespace-nowrap">
            Reward Pool
          </div>
        ),
        dataIndex: "reward_pool",
        render: (_text, record, _index) => (
          <div className="font-Montserrat text-sm sm:text-base font-medium lg:min-w-28">
            {record?.total_reward
              ? `${(record?.total_reward).toLocaleString("en-US")} ${record.token.symbol}`
              : "--"}
          </div>
        ),
      },
      {
        title: () => (
          <div className="font-Montserrat text-sm sm:text-base font-semibold whitespace-nowrap">
            Network
          </div>
        ),
        dataIndex: "network",
        render: (_text, record, _index) => (
          <div className="flex items-center gap-4 flex-nowrap">
            <img
              src={record.token?.chain?.logo}
              alt=""
              className="w-8 h-8 object-contain"
            />
            <span className="font-Montserrat text-sm sm:text-base font-medium">
              {record?.token?.chain?.name}
            </span>
          </div>
        ),
      },
      {
        title: () => (
          <div className="font-Montserrat text-sm sm:text-base font-semibold whitespace-nowrap">
            Amount
          </div>
        ),
        dataIndex: "amount",
        render: (_text, record, _index) => (
          <div className="font-Montserrat text-sm sm:text-base font-medium">
            {record?.allocation?.amount
              ? `${(record?.allocation?.amount).toLocaleString("en-US")} ${record.token.symbol}`
              : "--"}
          </div>
        ),
      },
      {
        title: () => (
          <div className="font-Montserrat text-sm sm:text-base font-semibold whitespace-nowrap">
            Token Address
          </div>
        ),
        dataIndex: "token.address",
        render: (_text, record, _index) => (
          <div className="flex gap-3 items-center">
            <div className="font-Montserrat font-medium text-sm sm:text-base">
              {shortenAddress(record?.token?.address || "")}
            </div>
            <IoCopy
              onClick={() => copyToClipboard(record?.token?.address || "")}
              className="cursor-pointer text-[#292D32]"
              size={18}
            />
          </div>
        ),
      },
      {
        title: () => (
          <div className="font-Montserrat text-sm sm:text-base font-semibold whitespace-nowrap">
            Status
          </div>
        ),
        dataIndex: "claim",
        fixed: "right",
        render: (_text, record, _index) => {
          if (!record.allocation)
            return (
              <div className="w-fit bg-[#E5E5E5] text-[#7891A5] font-semibold text-sm sm:text-base px-3 py-1 rounded-md">
                Not Eligible
              </div>
            );
          else if (record.allocation.claimed)
            return (
              <div className="w-24 h-9 flex justify-center items-center bg-[#0094FF1A] text-customBlue-500 rounded-md font-semibold text-sm sm:text-base">
                Claimed
              </div>
            );
          else
            return (
              <button
                onClick={() => handleClaimClick(record)}
                className="min-w-20 h-9 flex justify-center items-center bg-customBlue-500 rounded-md text-white font-semibold text-sm sm:text-base"
              >
                {loadingId === record.id ? (
                  <>
                    <style>{`
                      .my-spin-wrapper .ant-spin-dot-item {
                        background-color: white;
                      }
                    `}</style>
                    <Spin
                      size="small"
                      style={{ color: "white" }}
                      className="my-spin-wrapper"
                    />
                  </>
                ) : (
                  "Claim"
                )}
              </button>
            );
        },
      },
    ],
    [loadingId]
  );

  return (
    <Table<NFTAirdropType>
      columns={columns}
      dataSource={airdropNFTs || []}
      style={{ width: "100%" }}
      pagination={{
        pageSize: 10,
        hideOnSinglePage: true,
        position: ["bottomCenter"],
      }}
      scroll={{ x: "max-content" }}
      loading={loading}
    />
  );
};

export default AirdropNFT;
